module.exports = __webpack_public_path__ + "static/ansley-wine-logo-2-bbcd5ac1e9c9c407e1c9caf1fbd3d323.png";